import { Navigate } from 'react-router-dom';

// import { warn } from '@/utils/logger';

import { useAuth, exitHash } from './auth';

export const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const user = useAuth();

  // ! check explicit logout!
  // @2025/07/04
  const isExit = location.hash == `#${exitHash}`;
  // FIXME: parse shared drawing url to redirect after login
  // @2024/08/07
  const sharedURL = location.pathname + location.search;
  const redirectTo = encodeURIComponent(sharedURL);
  const target = isExit ? '/' : `/auth/login?redirectTo=${redirectTo}`;

  if (!user) {
    // warn(`## ProtectedRoute: user object is empty!`);
    return <Navigate to={target} replace />;
  }

  return children;
};
